import React, { Component } from "react";

import {
  MDBContainer,
  MDBRow,
  MDBCol,
  MDBCard,
  MDBCardImage,
  MDBCardBody,
  MDBCardTitle,
  MDBCardText,
  MDBBtn,
  Button,
} from "mdbreact";
import { Card, CardHeader } from "reactstrap";
import BreadCumb from "../Department/BreadCumb";
import { PostData } from "../../api/service";
import { Container, Typography } from "@material-ui/core";
import BreadCrumbOwn from "../Essentials/BreadCrumbOwn";

// const facultyData = [
//     {
//         name: 'Dr. Jogesh Kakati',
//         desg: 'Principal',
//         qualification: 'MA, PhD',
//         email: '',
//         phone: '',
//         mobile: '',
//         specifications: '',
//         cv: '',
//         photo: ''
//     },

// ]

export default class PresidentContainer extends Component {
  state = {
    facultyData: [],
    isLoaded: false,
    dept_code: "OFF",
  };

  componentDidMount() {
    let d = {
      dept_code: "OFF",
      type: "PRESIDENT",
    };

    PostData(`/getemployeebytype`, d).then((resp) => {
      //console.log(resp)
      this.setState({
        ...resp[0],
        facultyData: resp,
        isLoaded: true,
      });
    });
  }
  render() {
    return (
      <div>
        <BreadCrumbOwn title="President's Message" />

        <Container className="mb-5">
          <br />

          {this.state.isLoaded &&
            this.state.facultyData.map((el, index) => {
              return (
                <div>
                  {/* <Card style={{ boxShadow: 'none' }}>
                            <CardHeader style={{ color: 'white', boxShadow: 'none', backgroundColor: '#1E3760', textAlign: 'center' }}> <h3 style={{color: 'inherit'}}>{el.desg}</h3></CardHeader>
                        </Card> */}
                  <div>
                    <div style={{ textAlign: "left" }}>
                      <img
                        alt=""
                        src={el.dp.length > 0 ? el.dp[0] : ""}
                        style={{
                          width: "350px",
                          boxShadow: "1px 2px 10px rgba(0,0,0,0.1)",
                          border: `solid 5px wheat`,
                        }}
                      />
                    </div>

                    {/* <h5
                          style={{
                            fontSize: "16px",
                            textAlign: "left",
                            fontWeight: 700,
                          }}
                        >
                          {el.name}
                        </h5> */}
                    <h6 style={{ fontSize: "12px", textAlign: "right" }}>
                      <a href={`mailto:${el.email}`}>{el.email}</a>
                    </h6>
                    <h6 style={{ fontSize: "12px", textAlign: "right" }}>
                      <a href={`tel:${el.phone}`}>{el.phone}</a>
                    </h6>
                    <h6 style={{ fontSize: "12px", textAlign: "right" }}>
                      <a href={`tel:${el.mobile}`}>{el.mobile}</a>
                    </h6>
                    {/* <h6 style={{ fontSize: "12px", textAlign: "right" }}>
                          <a href={`tel:${el.mobile}`}>
                            {this.state.isLoaded && this.state.id != undefined && (
                              <a
                                style={{
                                  color: "#1892FF",
                                  cursor: "pointer",
                                  fontWeight: 700,
                                  textAlign: "right",
                                }}
                                // href={`/department/${this.state.dept_code}/faculty/single?id=${this.state.id}&name=${this.state.name}`}
                                href={el.cv.length > 0 ? el.cv[0] : ""}
                              >
                                Visit Profile
                              </a>
                            )}
                          </a>
                        </h6> */}
                  </div>
                  <div>
                    <div>
                      <Typography
                        variant="h5"
                        style={{ margin: "1em 0", fontWeight: 700 }}
                        gutterBottom
                      >
                        FROM THE PRESIDENT’S DESK
                      </Typography>
                      <Typography
                        style={{ textAlign: "justify" }}
                        variant="body1"
                        gutterBottom
                      >
                        I am glad to announce the commencement of the new
                        academic session 2026-2027 of Deendayal Upadhyaya
                        Adarsha Mahavidyalaya (PDUAM), Eraligool, Sribhumi. I am
                        pleased to inform you that the district of Sribhumi,
                        Assam, is a proud founding participant in the
                        establishment of Government Model Degree Colleges by the
                        Government of Assam. Since its inception in 2017, the
                        Mahavidyalaya has been offering higher education to the
                        aspirants of the rural areas of Sribhumi district, which
                        have long been deprived of access to modern Science
                        education. It is the earnest endeavour of the Government
                        of Assam to realize the vision of Pandit Deendayal
                        Upadhyaya by bringing the light of higher education to
                        the doorsteps of the rural and economically weaker
                        sections of the society. While access to higher
                        education remains a challenge for the underprivileged
                        communities in many developing countries, the Government
                        of India has taken commendable steps to ensure that
                        quality education is both affordable and accessible. In
                        line with this, the Govt of Assam has undertaken the
                        initiative to establish more model colleges in rural
                        regions lacking exposure to modern science education.
                      </Typography>

                      <br />

                      <Typography
                        style={{ textAlign: "justify" }}
                        variant="body1"
                        gutterBottom
                      >
                        {" "}
                        The Mahavidyalaya began its maiden academic journey from
                        the academic session 2017-2018 with the Higher Secondary
                        Science Stream and BSc (Honours and Pass) courses.
                        However, in the year 2023, Arts stream was introduced at
                        the Mahavidyalaya by the Department of Higher Education,
                        Government of Assam and the Mahavidyalaya has since then
                        evolved into a dual-stream institution, offering both
                        Science and Arts education, catering to a broader
                        spectrum of academic aspirations. I am proud to share
                        that in its first cycle of assessment by the National
                        Assessment and Accreditation Council (NAAC), Bangalore,
                        the Mahavidyalaya has come out with flying colours,
                        securing a prestigious B+ Grade. It stands as the only
                        college in the Sribhumi district to have achieved this
                        honour so far. Located 26 km from Sribhumi town, the
                        Mahavidyalaya has a vast campus spread over 30 Bighas of
                        land with modern buildings, a dedicated land of five
                        Bighas for playground, and well-facilitated residential
                        buildings for academic staff and a girls' hostel. Dr.
                        Jayasree Chakrabarty, an esteemed academician with an
                        illustrious career at Cotton College (now, Cotton
                        University), Guwahati, serves as the Founder Principal,
                        with her visionary leadership. Beyond academics, the
                        Mahavidyalaya actively engages in social and
                        community-oriented programmes for the welfare and
                        upliftment of local communities. I extend a warm
                        invitation to local educators, interested parents,
                        curious students, and the general public to contribute
                        to our mission of delivering quality higher education in
                        Science and Arts to the rural heartland of Sribhumi.
                      </Typography>
                      <br />
                      {/* <Typography
                        style={{ textAlign: "justify" }}
                        variant="body1"
                        gutterBottom
                      >The Government of Assam’s vision in establishing this higher education institution is deeply inspired by the ideals of the visionary statesman, social thinker, and integral humanist Pandit Deendayal Upadhyaya Ji, whose vision for socio-economic upliftment of rural communities continues to guide our mission. Access to higher education remains a significant challenge for underprivileged communities, especially in developing countries. Acknowledging this, the Government of India has taken it upon itself to deliver quality education to the rural population at their doorstep. In this regard, the establishment of model degree colleges like ours is a crucial step in meeting the educational needs of rural Assam.</Typography>
                       <br />
                      <Typography
                        style={{ textAlign: "justify" }}
                        variant="body1"
                        gutterBottom
                      >The Mahavidyalaya began its academic journey in the 2017-2018 session, offering Higher Secondary Science Stream and B.Sc. (both Honours and Pass) courses. The Mahavidyalaya is spread across a vast, lush campus of 30 bighas, featuring well-designed academic buildings and a sprawling five-bigha playground. Located in Eraligool, 26 km from Sribhumi town, our campus is easily accessible by various modes of transportation.</Typography>
                       <br />

<Typography
                        style={{ textAlign: "justify" }}
                        variant="body1"
                        gutterBottom
                      >The Mahavidyalaya also provides residential quarters for teaching and non-teaching staff, as well as a Girls' Hostel, ensuring a comfortable living environment for our community. Dr. Jayasree Chakrabarty, an esteemed academician with a distinguished tenure at Cotton College, Guwahati (now Cotton University), has been appointed as the Founding Principal of the Mahavidyalaya. Her dynamic leadership continues to shape the institution’s growth and development.</Typography>
                       <br />

<Typography
                        style={{ textAlign: "justify" }}
                        variant="body1"
                        gutterBottom
                      >Beyond academics, the Mahavidyalaya is committed to various social and academic initiatives aimed at enhancing the welfare of the surrounding communities. We sincerely invite the support of local educators, parents, students, and the general public to join hands in fulfilling our mission of delivering high-quality education in Sribhumi District. </Typography>
                      <br />

                      <Typography
                        style={{ textAlign: "justify" }}
                        variant="body1"
                        gutterBottom
                      >I warmly welcome all stakeholders to be part of the PDUAM, Eraligool family. Together, let us work towards a brighter future by upholding the values of education, progress, and innovation. As the Mahavidyalaya prepares for its upcoming NAAC assessment and accreditation, I request the active participation of all stakeholders in this important process.</Typography>
                      <br />

                      <Typography
                        style={{ textAlign: "justify" }}
                        variant="body1"
                        gutterBottom
                      >I extend my best wishes to all our students, faculty, and staff as we embark on this journey of collective achievement.</Typography>
                      <br /> */}

                      <div>
                        {/* <div style={{ textAlign: "right" }}>
                          <img
                            alt=""
                            src={el.dp.length > 0 ? el.dp[0] : ""}
                            style={{
                              width: "250px",
                              boxShadow: "1px 2px 10px rgba(0,0,0,0.1)",
                              border: `solid 5px wheat`,
                            }}
                          />
                        </div> */}

                        <h4
                          style={{
                            fontSize: "20px",
                            textAlign: "right",
                            fontWeight: 700,
                          }}
                        >
                          {el.name}
                        </h4>
                        <h6
                          style={{
                            fontSize: "14px",
                            textAlign: "right",
                            color: "black",
                          }}
                        >
                          <div
                            dangerouslySetInnerHTML={{ __html: el.designation }}
                          ></div>
                        </h6>
                        <h6 style={{ fontSize: "12px", textAlign: "right" }}>
                          <a href={`mailto:${el.email}`}>{el.email}</a>
                        </h6>
                        <h6 style={{ fontSize: "12px", textAlign: "right" }}>
                          <a href={`tel:${el.phone}`}>{el.phone}</a>
                        </h6>
                        <h6 style={{ fontSize: "12px", textAlign: "right" }}>
                          <a href={`tel:${el.mobile}`}>{el.mobile}</a>
                        </h6>
                        {/* <h6 style={{ fontSize: "12px", textAlign: "right" }}>
                          <a href={`tel:${el.mobile}`}>
                            {this.state.isLoaded && this.state.id != undefined && (
                              <a
                                style={{
                                  color: "#1892FF",
                                  cursor: "pointer",
                                  fontWeight: 700,
                                  textAlign: "right",
                                }}
                                // href={`/department/${this.state.dept_code}/faculty/single?id=${this.state.id}&name=${this.state.name}`}
                                href={el.cv.length > 0 ? el.cv[0] : ""}
                              >
                                Visit Profile
                              </a>
                            )}
                          </a>
                        </h6> */}
                      </div>
                    </div>
                  </div>
                </div>
              );
            })}
        </Container>
      </div>
    );
  }
}
